export function checkRuleEnabled(ruleValue: boolean | string) {
  const cleanedRule = (ruleValue ? String(ruleValue) : '').replace(/(\r\n|\n|\r)/gm, '');
  return cleanedRule === 'Yes';
}
